import ButtonComponent from '../../Basic/Button/Button.mjs';
import { StyledList } from '../../Basic/Lists/HorizontalList/Horizontal.styles.mjs';
import HorizontalList from '../../Basic/Lists/HorizontalList/HorizontalList.mjs';
import FlexContainer from '../../Containers/FlexContainer/FlexContainer.mjs';
import { StyledCurrentWeather } from '../CurrentWeather/CurrentWeather.styles.mjs';
import Search from '../Search/Search.mjs';
import styled from 'styled-components';

const StyledButton = styled(ButtonComponent) `
  @media screen and (max-width: ${props => props.theme.breakpoints.md}) {
    padding: 14px 16px 11px 12px;

    svg {
      position: relative;
      right: -3px;
    }
  }
`;
const StyledSearch = styled(Search) `
  width: 100%;
  flex: 1;

  @media screen and (max-width: ${props => props.theme.breakpoints.lg}) {
    display: none;
  }
`;
const StyledMobileSearch = styled(Search) `
  width: 100%;
  flex: 1;
`;
const StyledFlexContainer = styled(FlexContainer) `
  box-sizing: border-box;
`;
const StyledNavigation = styled.nav `
  box-sizing: border-box;
  width: 100%;
  position: relative;
  z-index: ${props => props.theme.zIndex.modal};
  box-shadow: 0px -1px 10px 0px ${props => props.theme.colors.black}26;

  ${StyledCurrentWeather} {
    margin: 0 14px 0 0;

    @media screen and (max-width: ${props => props.theme.breakpoints.xl}) {
      display: none;
    }

    @media screen and (min-width: ${props => props.theme.breakpoints.xxl}) {
      margin: 0 30px 0 0;
    }
  }

  ${StyledList} {
    margin: 0 auto;
  }
`;
const StyledHorizontalList = styled(HorizontalList) `
  @media screen and (max-width: ${props => props.theme.breakpoints.xl}) {
    display: none;
  }
`;
const StyledSearchIconButton = styled.button `
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all ${props => props.theme.animation.duration.quick1}
    ${props => props.theme.animation.easing.productive.standard};

  &:hover {
    background-color: ${props => props.theme.colors.darkGray}20;
  }

  &:active {
    transform: scale(0.95);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px ${props => props.theme.colors.mist}40;
  }
`;
const StyledTopNavigationLogoAnchor = styled.a `
  margin: 0 32px;

  @media screen and (min-width: ${props => props.theme.breakpoints.sm}) {
    margin: 0 0 0 40px;
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.xl}) {
    margin: 0 0 0 32px;
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.xxl}) {
    margin: 0 0 0 40px;
  }
`;
const StyledMobileSearchContainer = styled.div `
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: ${props => props.theme.colors.white};
  padding: 16px;
  box-shadow: 0px 2px 10px 0px ${props => props.theme.colors.black}26;
  z-index: ${props => props.theme.zIndex.modal};
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  box-sizing: border-box;
  min-height: 80px;

  @media screen and (min-width: ${props => props.theme.breakpoints.lg}) {
    display: none;
  }
`;
styled.button `
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all ${props => props.theme.animation.duration.quick1}
    ${props => props.theme.animation.easing.productive.standard};
  flex-shrink: 0;

  &:hover {
    background-color: ${props => props.theme.colors.darkGray}20;
  }

  &:active {
    transform: scale(0.95);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px ${props => props.theme.colors.mist}40;
  }
`;

export { StyledButton, StyledFlexContainer, StyledHorizontalList, StyledMobileSearch, StyledMobileSearchContainer, StyledNavigation, StyledSearch, StyledSearchIconButton, StyledTopNavigationLogoAnchor };
//# sourceMappingURL=TopNavigation.styles.mjs.map
